import { Request } from '@/api/Request'
import { PostRequest } from '@/api/PostRequest'
import { usePathFromBaseURI, useQuery } from '@/api/configuration/endpoints'
import { useAsyncState } from '@/infranstructure/useAsyncState'

export const useResendMessageToActorCommand = (transactionId: string, userId: string) => useAsyncState<boolean, string[]>(async (actorContact) => {
  const endpointUri = useQuery(() => usePathFromBaseURI('avissign', 'SessionProcess', 'ResendMessageToActor'),
    { name: 'userId', value: userId }, { name: 'transactionId', value: transactionId }, { name: 'actorContact', value: actorContact })
  const query = new PostRequest(new Request<void>(endpointUri.href), {})
  await query.response()
  return true
}, false, {
  immediate: false,
  onError(ex) {
    console.warn(ex)
  },
})

export const useResendMessageWithPhoneLikeToActorCommand = (transactionId: string, userId: string) => useAsyncState<boolean, string[]>(async (actorContact, externalSystemId, partnerId) => {
  const endpointUri = useQuery(
    () => usePathFromBaseURI('avissign', 'SessionProcess', 'ResendMessagesWithPhoneLikeChargingToActor'),
    { name: 'userId', value: userId }, { name: 'transactionId', value: transactionId }, { name: 'actorContact', value: actorContact },
    { name: 'partnerId', value: partnerId },
    { name: 'externalSystemId', value: externalSystemId.length ? externalSystemId[0] : '' },
  )
  const query = new PostRequest(new Request<void>(endpointUri.href), {})
  await query.response()
  return true
}, false, {
  immediate: false,
  onError(ex) {
    console.warn(ex)
  },
})

export const useSignCommand = (transactionId: string, userId: string) => useAsyncState<boolean, string[]>(async () => {
  const endpointUri = useQuery(() => usePathFromBaseURI('avissign', 'SessionProcess', 'SignDocument'),
    { name: 'userId', value: userId }, { name: 'transactionId', value: transactionId })
  const query = new PostRequest(new Request<void>(endpointUri.href), {})
  await query.response()
  return true
}, false, {
  immediate: false,
  onError(ex) {
    console.warn(ex)
  },
})
